export default __webpack_public_path__ + "files/webinar1.pdf";